import React from 'react'
import { useContext , useEffect} from 'react';
import { keyContext } from '../KeyContext';
import Modal from './Modal'


function NoteModal({shown,close}) {
  // const clientHeight = shown ?  document.getElementById('tes').clientHeight : ''
   
  const {leftMargin,setModalOpen} = useContext(keyContext)
  

    useEffect(() => {
      shown === true ? setModalOpen(true) :  setModalOpen(false)
    },[shown,setModalOpen])

    
  return shown ? (
   
    <div  className="modal-backdrop"  
       style={{top:'0px',width:'100%',height:'100%',left:leftMargin,backgroundColor:'rgba(0,0,0,0.5)'}}
     > 
    
     </div>
   

  )
  : ''
}

export default NoteModal